import { MCUserStatus } from 'src/shared/enums';

export const getMCStatus = (subscription: number) => {
  const status = subscription ?? 0;

  switch (status) {
    case MCUserStatus.UNSUBSCRIBED:
      return false;
    case MCUserStatus.SUBSCRIBED:
      return true;
  }
};
